module.exports = __webpack_public_path__ + "static/img/MANHATTAN-MAPLE.33fd5b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/MANHATTAN-MAPLE.png
// module id = ZbOi
// module chunks = 0